module.exports = __webpack_public_path__ + "img/番外_开国大典_03_龙椅.994d590d.png";